import React from "react";
import { motion } from "framer-motion";

export default function Manifesto({ manifesto = {} }) {
  const chapters = manifesto.chapters || [];
  return (
    <section
      id="quem-somos"
      data-testid="manifesto-section"
      className="relative bg-stone-950 py-14 md:py-20"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="max-w-2xl mb-10 md:mb-16">
          <motion.span
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            className="text-xs tracking-[0.3em] uppercase text-amber-500 font-semibold"
          >
            {manifesto.label || "Quem Somos"}
          </motion.span>
          <motion.h2
            initial={{ opacity: 0, y: 24 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ delay: 0.1, duration: 0.8 }}
            className="font-serif text-4xl sm:text-5xl lg:text-6xl tracking-tight text-stone-50 mt-4"
          >
            {manifesto.title || "Nossa História"}
          </motion.h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 md:gap-8">
          {chapters.map((ch, i) => (
            <motion.div
              key={i}
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ delay: i * 0.12, duration: 0.8 }}
              data-testid={`manifesto-chapter-${i}`}
              className="border-t border-stone-800 pt-8"
            >
              <span className="font-serif text-6xl md:text-7xl text-amber-600/80 leading-none">
                {ch.number}
              </span>
              <h3 className="font-serif text-2xl text-stone-50 mt-6">{ch.title}</h3>
              <p className="text-stone-400 leading-relaxed mt-4">{ch.text}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
